// Hides non-essential navbar chrome (version badge, env pill) once the
// @container/navbar narrows past the point where the workspace name and the
// right-hand controls still fit. One constant so the collapse breakpoint is
// tuned in a single place.
export const NAVBAR_NARROW_HIDDEN = '@max-[610px]/navbar:hidden';
